import { useMutation, useQueryClient } from "@tanstack/react-query";

import useGetAccessToken from "components/Login/useGetAccessToken";
import type { ShareLinkListItem } from "../methods/shareFile";
import { revokeShareLink } from "../methods/shareFile";
import { SHARES_QUERY_KEY } from "./shareKeys";

/**
 * Revoke a file's share link (file-api ADR 036). Drops the revoked token from
 * the cached shares list directly — avoiding invalidate so stopping sharing
 * doesn't trigger an extra GET while the modal is open.
 */
export default function useRevokeShareLink(fileId: string) {
  const getAccessToken = useGetAccessToken();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (token: string) =>
      revokeShareLink(fileId, token, getAccessToken).then(() => token),
    onSuccess: (token) => {
      queryClient.setQueryData<ShareLinkListItem[]>(
        SHARES_QUERY_KEY(fileId),
        (prev) => prev?.filter((link) => link.token !== token)
      );
    },
    onError: (error) => {
      console.error("Failed to stop sharing file:", error);
    },
  });
}
